export const ADMIN_ROLE_NAME = 'super-admin'
